import {AfterViewInit, Component, inject, Input, OnInit, signal, ViewChild} from '@angular/core';
import {
  NgbActiveModal,
  NgbDateAdapter,
  NgbDateParserFormatter,
  NgbDatepickerI18n,
  NgbTimeAdapter,
  NgbTimepickerI18n
} from "@ng-bootstrap/ng-bootstrap";
import {FormsModule, NgForm} from "@angular/forms";
import {SharedCommonModule} from "../../../../../shared/commons/shared-common.module";
import {
  HospitalAutocompleteComponent
} from "../../../../../shared/components/hospital-autocomplete/hospital-autocomplete.component";
import {ExcludedHospitalsDto} from "../../../../../../generated-model/model";
import {NgIf} from "@angular/common";
import {CrudMode, scrollToInvalidElement, updateFormAndValidity} from "../../../../../app.constants";
import {ToastService} from "../../../../../shared/commons/toast/toast-service";
import {SuccessDialogService} from "../../../../../shared/commons/dialog/success-dialog/success-dialog.service";
import {ExcludedHospitalsResource} from "../../../../../service/ExcludedHospitalsResource";
import {GtNgDatepickerModule} from "../../../../../shared/commons/gt-ng-datepicker/gt-ng-datepicker.module";
import {CustomDatepickerI18n, I18n} from "../../../../../shared/commons/gt-ng-datepicker/custom-datepicker";
import {CustomNgbDateNativeAdapterToString} from "../../../../../shared/commons/gt-ng-datepicker/date-native-adaptor";
import {CustomNgbDateParser} from "../../../../../shared/commons/gt-ng-datepicker/custom-ngb-date-parser";
import {CustomNgbTimeAdapter} from "../../../../../shared/commons/gt-ng-datepicker/custom-time-native-adaptor";
import {CustomTimepickerI18n} from "../../../../../shared/commons/gt-ng-datepicker/custom-timepicker";
import {
  GtNgDatepickerMaskDirective
} from "../../../../../shared/commons/gt-ng-datepicker/gt-ng-datepicker-mask.directive";
import {GtNgDatepickerComponent} from "../../../../../shared/commons/gt-ng-datepicker/gt-ng-datepicker.component";

@Component({
  selector: 'app-add-group-register-hospital-modal',
  templateUrl: './excluded-hospitals-modal.component.html',
  styleUrls: ['./excluded-hospitals-modal.component.css'],
  imports: [
    SharedCommonModule,
    FormsModule,
    HospitalAutocompleteComponent,
    NgIf,
    GtNgDatepickerModule
  ],
  providers: [
    I18n,
    {provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n},
    {provide: NgbDateAdapter, useClass: CustomNgbDateNativeAdapterToString},
    {provide: NgbDateParserFormatter, useClass: CustomNgbDateParser},
    {provide: NgbTimeAdapter, useClass: CustomNgbTimeAdapter},
    {provide: NgbTimepickerI18n, useClass: CustomTimepickerI18n},
    GtNgDatepickerMaskDirective
  ],
  standalone: true
})
export class ExcludedHospitalsModalComponent implements OnInit, AfterViewInit {
  @ViewChild("form", {read: NgForm, static: true}) form: NgForm;
  @ViewChild("dateOutInput", {read: GtNgDatepickerComponent, static: true}) dateOutInput: GtNgDatepickerComponent;
  formId = signal('excludedHospitalsForm');
  @Input({required: true}) item: ExcludedHospitalsDto;
  @Input({required: true}) crud: CrudMode;
  toastService = inject(ToastService);
  excludedHospitalsResource = inject(ExcludedHospitalsResource);
  private readonly successDialogService = inject(SuccessDialogService);

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
  }

  close() {
    this.activeModal.close(false);
  }

  save() {
    console.log('form submitted.');
    let valid = updateFormAndValidity(this.form);
    if (valid) {
      console.log('valid');
      this.excludedHospitalsResource.save(this.item)
        .subscribe(value => {
          this.activeModal.close(value);
          this.successDialogService.open('บันทึกข้อมูลเรียบร้อยแล้ว')
        });
    } else {
      console.log('invalid')
      this.toastService.showWarning("กรุณากรอกข้อมูลให้ครบถ้วน");
      try {
        scrollToInvalidElement(this.formId());
      } catch (e) {
        //do nothing.
      }
    }
  }

  onDateOutChange(dateOut) {
    // console.log('dateOut changes ', dateOut);
  }
}
